import Swal from "sweetalert2";
import axios from "../../axios";
import { ADD_COLOR, DELETE_COLOR, GET_COLORS, UPDATE_COLOR } from "../types";
import { setAlert } from "./alert";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const getColors = () => async (dispatch) => {
  try {
    const res = await axios.get("color/all");
    if (res.data.code === 1) {
      dispatch({ type: GET_COLORS, payload: res.data.data });
    }
  } catch (err) {
    const errorMessage = getErrorMessage(err.response?.data);
    Swal.fire({
      title: 'Error!',
      text: errorMessage,
      icon: 'error',
    });
  }
};
export const addColor = (data, isFormData = false) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    };

    const res = await axios.post("color/add", data, config);

    if (res.data.code === 1) {
      dispatch({ type: ADD_COLOR, payload: res.data.data });
      Swal.fire({ title: "Success!", text: res.data.message, icon: "success" });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({ title: "Warning!", text: res.data.message, icon: "warning" });
    }
  } catch (err) {
    const errMsg = err?.response?.data?.message || err.message || "Something went wrong";
    dispatch(setAlert(errMsg, "danger"));
    Swal.fire({ title: "Error!", text: errMsg, icon: "error" });
  }
};

export const updateColor = (data, isFormData = false) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    };

    const res = await axios.post("color/update", data, config);

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_COLOR, payload: res.data.data });
      Swal.fire({ title: "Success!", text: res.data.message, icon: "success" });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({ title: "Warning!", text: res.data.message, icon: "warning" });
    }
  } catch (err) {
    const errMsg = err?.response?.data?.message || err.message || "Something went wrong";
    dispatch(setAlert(errMsg, "danger"));
    Swal.fire({ title: "Error!", text: errMsg, icon: "error" });
  }
};

export const updateColorStatus = (id, status) => async (dispatch) => {
  try {
    // const updatedFormData = { ...formData, id: formData._id };
    // console.log("formdata updateCustomerStatus:", id, status);

    const res = await axios.post(
      "color/update",
      { id, status },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_COLOR, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // Use the global error message function
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: 'Error!',
      text: errorMessage,
      icon: 'error',
    });
  }
};

export const deleteColor = (id) => async (dispatch) => {
  if (!id) {
    dispatch(setAlert("Please select a record to delete", "warning"));
    return false;
  }

  try {
    const res = await axios.post(`color/delete/${id}`);

    if (res.data.code === 1) {
      dispatch({ type: DELETE_COLOR, payload: { id } });
      Swal.fire({ title: "Success!", text: res.data.message, icon: "success" });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      Swal.fire({ title: "Warning!", text: res.data.message, icon: "warning" });
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    const errorMessage = getErrorMessage(err.response?.data);
    Swal.fire({ title: "Error!", text: errorMessage, icon: "error" });
    dispatch(setAlert(errorMessage, "danger"));
  }
};
